import DeliveryAddressService from '../../services/DeliveryAddressService';
import deliveryAddressUseCase from './deliveryAddressUseCase';

const deliveryAddressFactory = deliveryAddressUseCase({
  DeliveryAddressService: DeliveryAddressService(),
});

export default deliveryAddressFactory;
